module.exports = __webpack_public_path__ + "img/free-home-icon-2502-thumb.463f29bd.png";